module.exports = __webpack_public_path__ + "static/7-e4763893f87a4f937fba5d9ee88f193d.jpg";